<div class="license-country">{{ country }}</div>
<div class="license-code">{{ code }}</div>
